var camelizeRE = /-(\w)/g;
export function camelize(str) {
    return str.replace(camelizeRE, function (_, c) { return c.toUpperCase(); });
}
export function camesplitlize(str) {
    return str
        .replace(/([A-Z])/g, '-$1')
        .toLowerCase()
        .replace(/-/, '');
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/utils/transformName.js
// module id = null
// module chunks = 